
import { TextFieldHelper } from "@goodgamestudios/core";
import { MathBase } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { TextFieldType } from "@goodgamestudios/createjs-utilities";
import { KeyboardEvent } from "@goodgamestudios/createjs-utilities";
import { Keyboard } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { PokerGameTypes } from "../../../constants/PokerGameTypes";
import { SFConstants } from "../../../constants/SFConstants";
import { Balancing } from "../../../constants/shared/Balancing";
import { Poker2SoundController } from "../../../controller/Poker2SoundController";
import { Poker2OnTableEvent } from "../../../event/Poker2OnTableEvent";
import { Poker2SliderEvent } from "../../../event/Poker2SliderEvent";
import { Poker2TutorialEvent } from "../../../event/Poker2TutorialEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { TurnTimerComponent } from "../../components/playerContainer/TurnTimerComponent";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2TakeSeatDialogProperties } from "./Poker2TakeSeatDialogProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2TakeSeatDialog extends Poker2Dialog {
    private static BIG_BLIND_STEP_FACTOR: number = 10;
    public static NAME: string = "Poker2TakeSeatDialog";

    //its the type of S2C_GAME_BOOK_SEAT
    private PLAYER_TAKE_SEAT: number = 1;
    private PLAYER_LOST_CHIPS: number = 2;
    private PLAYER_TIME_OUT: number = 3;
    private TUTORIAL_SMALL_BLIND: number = 25;
    private TUTORIAL_BUYIN: number = 400;
    private slider: SliderHelperStepper;
    private buyIn: number = NaN;
    private minBuyIn: number = NaN;
    private maxBuyIn: number = NaN;
    private _stepSizeNumeric: number = NaN;
    private turnTimer: TurnTimerComponent;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();

        this.slider = new SliderHelperStepper(this.takeSeatDialog.slider);
        this.takeSeatDialog.mc_input.txt_input.restrict = "0-9";
        this.takeSeatDialog.mc_input.txt_input.maxChars = 9;
        this.initTextFields();
    }

    private handleTurnTimerEvent(progress: number): void {

        switch (progress) {
            case 0.5:
                this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_TIME);
                break;

            case 1:
                this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_LATE);
                if (this.turnTimer) {
                    this.turnTimer.stopAll();
                    this.turnTimer = null;
                }
                this.hide();
                break;
        }
    }

    protected applyProperties(): void {

        var copy: string;
        var tablefee: number = int(Poker2Model.onTableData.currentTable.sBlind);

        if (Poker2Model.onTableData.currentTable.gameType == PokerGameTypes.DEFAULT_TABLE_TYPE_STANDARD || Poker2Model.onTableData.currentTable.gameType == PokerGameTypes.DEFAULT_TABLE_TYPE_FAST) {
            this.minBuyIn = Poker2Model.onTableData.currentTable.sBlind * 20;
        }
        else if (Poker2Model.onTableData.currentTable.gameType == PokerGameTypes.DEFAULT_TABLE_TYPE_MIN50BB) {
            this.minBuyIn = Poker2Model.onTableData.currentTable.sBlind * 100;
        }
        this.takeSeatDialog.btn_moreGold.visible = Poker2Model.userData.userCash < this.minBuyIn + Poker2Model.onTableData.currentTable.sBlind;
        this.takeSeatDialog.btn_ok.enableButton = Poker2Model.userData.userCash >= this.minBuyIn + Poker2Model.onTableData.currentTable.sBlind;
        if (this.tutorialController.isActive) {
            this.takeSeatDialog.slider.visible = false;
            this.takeSeatDialog.mc_input.txt_input.type = TextFieldType.DYNAMIC;
            this.takeSeatDialog.mc_input.txt_input.selectable = false;
        }
        else {
            this.takeSeatDialog.mc_input.txt_input.type = TextFieldType.INPUT;
            this.takeSeatDialog.mc_input.txt_input.selectable = true;
            this.takeSeatDialog.slider.visible = Poker2Model.userData.userCash >= this.minBuyIn + Poker2Model.onTableData.currentTable.sBlind;
        }
        this.takeSeatDialog.mc_input.visible = Poker2Model.userData.userCash >= this.minBuyIn + Poker2Model.onTableData.currentTable.sBlind;

        if ((Poker2Model.onTableData.currentTable.sBlind * 400) < Poker2Model.userData.userCash) {
            this.maxBuyIn = Poker2Model.onTableData.currentTable.sBlind * 400;
        }
        else {
            this.maxBuyIn = Poker2Model.userData.userCash - Poker2Model.onTableData.currentTable.sBlind;
        }

        this.takeSeatDialog.txt_fee_value.visible = (this.takeSeatDialogProperties.showTablePrice);
        this.takeSeatDialog.txt_fee.visible = (this.takeSeatDialogProperties.showTablePrice);

        this.takeSeatDialog.txt_fee_value.text = NumberStringHelper.groupString(Poker2Model.onTableData.currentTable.sBlind, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.takeSeatDialog.txt_min_value.text = NumberStringHelper.groupString(this.minBuyIn, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.takeSeatDialog.txt_max_value.text = NumberStringHelper.groupString(Poker2Model.onTableData.currentTable.sBlind * 400, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.takeSeatDialog.txt_chips_value.text = NumberStringHelper.groupString(Poker2Model.userData.userCash, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));

        if (Poker2Model.userData.userCash >= (Poker2Model.onTableData.currentTable.sBlind * 400) / 2 + tablefee) {
            this.buyIn = (Poker2Model.onTableData.currentTable.sBlind * 400) / 2;
        }
        else if (Poker2Model.userData.userCash >= (Poker2Model.onTableData.currentTable.sBlind * 20)) {
            this.buyIn = Poker2Model.onTableData.currentTable.sBlind * 20;
        }
        else if (Poker2Model.userData.userCash < (Poker2Model.onTableData.currentTable.sBlind * 20)) {
            this.buyIn = Poker2Model.onTableData.currentTable.sBlind * 20;
        }

        this.takeSeatDialog.mc_input.txt_input.text = String(this.buyIn);

        // calculate numeric step size
        this._stepSizeNumeric = this.calculateNumericStepSize();
        // initialize stepwise slider
        this.slider.initSliderStepper(this.minBuyIn, this.maxBuyIn, this._stepSizeNumeric, this.buyIn, this.takeSeatDialog.mc_input.txt_input);

        if (Poker2Model.userData.userCash < this.minBuyIn + Poker2Model.onTableData.currentTable.sBlind) {
            copy = Poker2Model.languageData.getTextById("take_seat_copy_noBuyin");
            this.takeSeatDialog.txt_title.text = Poker2Model.languageData.getTextById("take_seat_title");
        }
        else {
            switch (this.takeSeatDialogProperties.type) {
                case this.PLAYER_TAKE_SEAT:
                    this.takeSeatDialog.txt_title.text = Poker2Model.languageData.getTextById("take_seat_title");
                    copy = Poker2Model.languageData.getTextById("take_seat_copy");
                    break;
                case this.PLAYER_LOST_CHIPS:
                    this.takeSeatDialog.txt_title.text = Poker2Model.languageData.getTextById("take_seat_title_chipsOut");
                    copy = Poker2Model.languageData.getTextById("take_seat_copy_timeOut");
                    break;
                case this.PLAYER_TIME_OUT:
                    this.takeSeatDialog.txt_title.text = Poker2Model.languageData.getTextById("take_seat_title_timeOut");
                    copy = Poker2Model.languageData.getTextById("take_seat_copy_chipsOut");
                    break;
            }
            // create register timer
            if (!this.turnTimer && !this.tutorialController.isActive) {
                this.turnTimer = new TurnTimerComponent();
                this.turnTimer.onTurnTimerCallbackTrigger = this.bindFunction(this.handleTurnTimerEvent);
                this.takeSeatDialog.mc_clockHolder.addChild(this.turnTimer);
                this.turnTimer.startTimer(this.takeSeatDialogProperties.bookTime);
            }
        }
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.takeSeatDialog.txt_copy, copy);
        if (this.tutorialController.isActive) {
            this.takeSeatDialog.btn_cancle.enabled = false;
            switch (this.tutorialController.tutorialState) {
                case "tut_step5_buyIn":
                    this.updatePosition();
                    Poker2Model.onTableData.currentTable.sBlind = this.TUTORIAL_SMALL_BLIND;
                    this.takeSeatDialog.mc_input.txt_input.text = String(this.TUTORIAL_BUYIN);
                    this.takeSeatDialog.txt_fee_value.text = String(0);
                    this.takeSeatDialog.txt_min_value.text = String(this.TUTORIAL_BUYIN / 2);
                    this.takeSeatDialog.txt_max_value.text = String(this.TUTORIAL_BUYIN * 2);
                    this.layoutManager.tutPanel.showTutorialArrow(this.takeSeatDialog.btn_ok, true, true);
                    break;
            }
        }
        else {
            this.takeSeatDialog.btn_cancle.enabled = true;
        }

    }

    private calculateNumericStepSize(): number {
        var bigBlind: number = Poker2Model.onTableData.currentTable.sBlind * 2;
        return Poker2TakeSeatDialog.BIG_BLIND_STEP_FACTOR * bigBlind;
    }

    public show(): void {
        super.show();
        this.takeSeatDialog.slider.addEventListener("onSliding", this.bindFunction(this.onSliding));
        this.takeSeatDialog.slider.addEventListener("slideUp", this.bindFunction(this.onSliding));
        this.takeSeatDialog.slider.addEventListener("slideDown", this.bindFunction(this.onSliding));
    }

    public hide(): void {
        super.hide();
        this.takeSeatDialog.slider.removeEventListener("onSliding", this.bindFunction(this.onSliding));
        this.takeSeatDialog.slider.removeEventListener("slideUp", this.bindFunction(this.onSliding));
        this.takeSeatDialog.slider.removeEventListener("slideDown", this.bindFunction(this.onSliding));
        if (this.turnTimer) {
            this.turnTimer.stopAll();
            this.turnTimer = null;
        }
    }

    public destroy(): void {
        super.destroy();

        if (this.slider)
            this.slider.destroy();
        this.slider = null;
    }

    protected onKeyUp(event: KeyboardEvent): void {
        if (event.keyCode == Keyboard.ENTER) {
            var buyInValue: number = NaN;
            buyInValue = MathBase.max(this.minBuyIn, MathBase.min(this.maxBuyIn, parseFloat(this.takeSeatDialog.mc_input.txt_input.text)));
            this.takeSeatDialog.mc_input.txt_input.text = String(buyInValue);
            this.takeSeatDialog.btn_ok.enableButton = buyInValue + Poker2Model.onTableData.currentTable.sBlind <= Poker2Model.userData.userCash;
        }
    }

    // TODO: testing the functionality
    private onSliding(event: Poker2SliderEvent): void {
        // ignore changes to binded input fields to slider
        if (event.onInputFieldChanged) {
            return;
        }

        //			var min:Number = Poker2Model.onTableData.currentTable.sBlind * 20;
        var max: number = NaN;

        if ((Poker2Model.onTableData.currentTable.sBlind * 400) < Poker2Model.userData.userCash + Poker2Model.onTableData.currentTable.sBlind)
            max = Poker2Model.onTableData.currentTable.sBlind * 400;
        else
            max = Poker2Model.userData.userCash - Poker2Model.onTableData.currentTable.sBlind;

        var result: string;
        if (event.type == "slideUp" || event.type == "slideDown") {
            // take stepwise values from SliderStepper component
            result = event.numericValue.toString();
        }
        else {
            // calulates stepless values
            result = String(Math.round(this.minBuyIn + ((max - this.minBuyIn) * event.percentValue / 100)));
        }

        // show result
        this.takeSeatDialog.mc_input.txt_input.text = result;
    }

    private initTextFields(): void {
        this.takeSeatDialog.btn_ok.label = Poker2Model.languageData.getTextById("btn_addcurrency");
        this.takeSeatDialog.btn_cancle.label = Poker2Model.languageData.getTextById("generic_btn_goback");
        this.takeSeatDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.takeSeatDialog.txt_min, Poker2Model.languageData.getTextById("take_seat_min"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.takeSeatDialog.txt_max, Poker2Model.languageData.getTextById("take_seat_max"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.takeSeatDialog.txt_chips, Poker2Model.languageData.getTextById("take_seat_chips"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.takeSeatDialog.txt_fee, Poker2Model.languageData.getTextById("take_seat_fee"));
        this.takeSeatDialog.btn_moreGold.label = Poker2Model.languageData.getTextById("dialog_nomoney_btn_moregold");
    }

    protected onClick(event: MouseEvent): void {
        if (instanceOfClass(event.target, "TextField"))
            return;

        if (this.tutorialController.isActive) {

            switch (this.tutorialController.tutorialState) {
                case "tut_step5_buyIn":
                    if (event.target == this.takeSeatDialog.btn_ok) {
                        this.tutorialController.nextStep();
                        this.hide();
                    }
                    break;
            }
            return;
        }

        super.onClick(event);

        switch (event.target) {
            case this.takeSeatDialog.btn_cancle:
                this.controller.dispatchEvent(new Poker2OnTableEvent("unlockJoinButtons"));
                this.bookRelease();
                this.hide();
                break;
            case this.takeSeatDialog.btn_ok:
                if (this.takeSeatDialog.btn_ok.enabled) {
                    var buyInValue: number = MathBase.max(this.minBuyIn, MathBase.min(this.maxBuyIn, parseFloat(this.takeSeatDialog.mc_input.txt_input.text)));

                    if (this.takeSeatDialog.mc_input.txt_input.text != String(buyInValue)) {
                        this.takeSeatDialog.mc_input.txt_input.text = String(buyInValue);
                    }
                    else {
                        this.hide();
                        Poker2Model.onTableData.buyIn = buyInValue;
                        BasicModel.smartfoxClient.sendMessage("gsi", [JSON.stringify({ index: this.takeSeatDialogProperties.seatId, buyIn: Poker2Model.onTableData.buyIn })]);
                    }
                }
                break;
            case this.takeSeatDialog.btn_moreGold:
                if (Poker2Model.userData.isGuest())
                    this.controller.onStartRegisterDialog();
                else
                    this.controller.onClickMoreMoney(null);
                this.hide();
                break;
        }
    }
    private bookRelease(): void {
        BasicModel.smartfoxClient.sendMessage("gbr", [JSON.stringify({ seatId: this.takeSeatDialogProperties.seatId })]);
    }

    protected onTutorialEvent(event: Poker2TutorialEvent): void {

        switch (this.tutorialController.tutorialState) {
            case "tut_step4_freeSeat":
                this.hide();
                break;
        }
    }

    protected get takeSeatDialogProperties(): Poker2TakeSeatDialogProperties {
        return this.properties as Poker2TakeSeatDialogProperties;
    }

    protected get takeSeatDialog(): Library.PokerInterface.PokerTakeSeat {
        return this.disp as Library.PokerInterface.PokerTakeSeat;
    }
}
import { Poker2TutorialController } from "../../../controller/Poker2TutorialController";
import { SliderHelperStepper } from "../../helper/SliderHelperStepper";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
